export default __webpack_public_path__ + "static/media/O.fc661ba6.jpg";